<script setup lang="ts">
import AuthenticatedVImg from '../AuthenticatedVImg.vue'

defineProps<{
  src: string
}>()
</script>

<template>
  <div class="reply-preview-thumbnail">
    <AuthenticatedVImg
      :src="src"
      purpose="attachment"
      alt=""
    />
  </div>
</template>

<style scoped>
.reply-preview-thumbnail {
  width: 34px;
  height: 34px;
  min-width: 34px;
  min-height: 34px;
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;
}

.reply-preview-thumbnail :deep(.authenticated-v-img) {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
